import { extendTheme } from '@chakra-ui/react';

export default extendTheme({
  colors: {
    knicks: {
      50: '#fbc9a0',
      100: '#f9bb88',
      200: '#f8ad6f',
      300: '#f7a057',
      400: '#f6923e',
      500: '#F58426',
      600: '#f4760e',
      700: '#de6a0a',
      800: '#c55f09',
      900: '#ad5308',
    },
  },
});
